import React from "react";
import Logo from "./Logo";
import Avatar from "./Avatar";

function Navbar({roles, openModal, colourBlindMode, onColourBlindMode, offColourBlindMode}) {
    return (
        <nav
            className="navbar navbar-dark bg-[#3d3e44]"
            style={{ position: "fixed", top: "0px", width: "100%" }}
        >
            <span>
                <i className="fa-solid fa-bars fa-2xl bar-icon"></i>
            </span>
            <Logo />
            <Avatar 
                roles={roles}
                openModal={openModal}
                colourBlindMode={colourBlindMode}
                onColourBlindMode={onColourBlindMode}
                offColourBlindMode={offColourBlindMode}
            />
        </nav>
    );
}

export default Navbar;
